import type { ElementDefinition } from '../../utils'
import { dialog } from '../dialog'
import { mediaItem } from '../media/media-item'
import { ProductUgc, ProductUgcDefinitionOptions } from './product-ugc.element'
import { ProductUgcStyles as styles } from './product-ugc.styles'
import { ProductUgcTemplate as template } from './product-ugc.template'

/**
 * ProductUgc definition
 * @public
 */
export const productUgc: ElementDefinition<ProductUgc, ProductUgcDefinitionOptions> = {
  baseClass: ProductUgc,
  baseName: 'product-ugc',
  template,
  styles,
  dependencies: [dialog, mediaItem],
  options: {}, // TODO: maybe add options
}
